import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import { Formik, Form } from 'formik';
import { Select2 } from 'view/component/FormFormik';
import apiService from 'apiService';
import { showLoading, toast } from 'view/component/Alert';

const ModalAdd = (props) => {
    const Post = async (param) => {
        showLoading('menyimpan')
        let res = await apiService.post('/registration/flags/create', param)
        if (res.code == 200) {
            props.data.changeReFlags(res.data)
            toast({ status: 'success', text: 'berhasil ditambah' })
            props.onHide()
        }
    }
    const handleSubmit = () => {
        console.log(props.data)
        let param = {
            patient_id: props.data.patient?.id,
            flag_id: []
        }
        props.data.value.map((a, k) => {
            param.flag_id.push(a.value)
        })
        if (param.patient_id) { 
            Post(param) 
        } else {
            props.onHide()
        }
    }
    return (
        <div>
            <Modal {...props} aria-labelledby='modal-user'>
                <ModalHeader closeButton>
                    <ModalTitle>
                        <h3>Tambah Flags Untuk Pasien</h3>
                    </ModalTitle>
                </ModalHeader>
                <Formik
                    enableReinitialize
                    initialValues={{
                        flags: props.data.value
                    }}
                    // validationSchema={SignupSchema}
                    onSubmit={values => {
                        handleSubmit()
                    }}
                >
                    {({ errors, touched }) => (
                        <Form className="col-md-12">
                            <ModalBody>

                                <Select2
                                    name="flags"
                                    onChange={(e) => props.data.onChangeflags(e)}
                                    value={props.data.value}
                                    errors={errors}
                                    touched={touched}
                                    icon="ni ni-circle-08"
                                    type="text"
                                    label="Pilih Flags"
                                    option={props.data.refFlags}
                                    isMulti ={true}
                                />

                            </ModalBody>
                            <ModalFooter>
                                <button
                                    type='button'
                                    onClick={() => {
                                        props.onHide();
                                    }}
                                    className='btn btn-secondary'>
                                    Batal
                            </button>
                                <button type='submit' className='btn btn-primary'>
                                    Simpan Data
                            </button>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </div>
    )
}
export default ModalAdd
